import React from 'react';
import {CircularProgress} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';

type HeaderActionButtonProps = {
    loading: boolean
    bgColor: string
    label: string
    handleAction: () => void
    disabled: boolean
    icon?: React.ReactNode|null
    shortcut?:string|null
}

const HeaderActionButton: React.FC<HeaderActionButtonProps> = ({ loading, disabled, bgColor, label = "", handleAction, icon = <InsertEmoticonIcon/>, shortcut = null}) => {
    return (
            <LoadingButton loading={loading}
                           loadingIndicator={<CircularProgress color="inherit" size={16} />}
                           variant="outlined" sx={{bgcolor:bgColor}}
                           onClick={handleAction} disabled={disabled}
                           title={label}>
                {icon} {shortcut}
            </LoadingButton>
    );
};

export default HeaderActionButton;